// @ts-nocheck
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Grid,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";
import styles from "./nonUserModal.module.css";
import * as Yup from "yup";
import { useFormik } from "formik";
import { CustomInput } from "../../../components/Custom/Input";
import { AddressFilterAutocomplete } from "../../../components/Custom/react-google-maps/AddressAutoComplete";
import React, { useCallback, useEffect, useMemo } from "react";
import { useState } from "react";
import { getMobileFormat } from "../../../utils/methods/formatters";
import { useDispatch, useSelector } from "react-redux";
import { ALERT_DIALOG } from "../../../store/constants/auth";
import { BarToggle } from "../../../components/Others/BarToggle";
import { CustomBusinessInput } from "../../contractors/components/AddContractorForms/_components/CustomBusinessInput";
import { getCssVariableHandler } from "../../../utils/styles/getCssVariables";
import { contractorTypes } from "../../contractors/components/AddContractorForms/formSchemas/addContractorStep1Schema";
import { isUserRole } from "../../../utils/methods/storeFunc";
import { USER_ROLES } from "../../../staticData/userRoles";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  boxShadow: 24,
  p: 4,
  minWidth: "700px",
  borderRadius: "16px",
  padding: "20px",
  border: "2px solid #D175B6",
  backgroundColor: "#000",
  zIndex: 9,
  "@media (max-width: 600px)": {
    minWidth: "96vw",
    maxHeight: "96vh",
    width: "97vw",
    overflowY: "auto",
  },
};

export const SendOppToNonUserModal = ({
  open,
  handleClose,
  isInvite = false,
  positionData,
  onSubmit,
  isLoading = false,
}) => {
  const contractorTypesSelectOptions = useMemo(() => {
    return [
      {
        value: "1099",
        label: "1099",
      },
      {
        value: "V.C.",
        label: "V.C.",
      },
      {
        value: "w2",
        label: "W2",
      },
    ];
  }, []);

  // useState..
  const [is3rdParty, setIs3rdParty] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [sendEmail, setSendEmail] = useState(false);
  // useState..

  // useSelector...
  const auth = useSelector((store) => store.auth);
  const { links } = useSelector((state) => state?.contractorLink);
  // useSelector...

  // useDispatch...
  const dispatch = useDispatch();
  // useDispatch...

  const [isSubmitting, setIsSubmitting] = useState(false);
  const initialValues = {
    firstName: "",
    middleName: "",
    lastName: "",
    email: "",
    phone: "",
    city: "",
    state: "",
    companyName: "",
    contractorType: "",
    thirdPartyContractorId: null,
  };

  const validationSchema = Yup.object().shape(
    {
      firstName: Yup.string()
        .trim()
        .required("Legal First name is required")
        .max(100, "Legal First Name should at most 100 characters."),
      middleName: Yup.string()
        .trim()
        .max(100, "Legal Middle Name should at most 100 characters."),
      lastName: Yup.string()
        .trim()
        .required("Legal Last name is required")
        .max(100, "Legal Last Name should at most 100 characters."),
      email: Yup.string()
        .trim()
        .email()
        .required("Email is required")
        .max(50, "Email should at most 50 characters."),
      contractorType: is3rdParty
        ? Yup.string().notRequired()
        : Yup.string()
            .oneOf(["1099", "V.C.", "w2", "thirdParty", "outsource"])
            .required("Contractor Type is required"),
      phone: Yup.string()
        .required("Phone number is required")
        .matches(/^\d{3}-\d{3}-\d{4}$/, "Phone number must be of 10 digit"),
      city: Yup.string().trim().max(50, "City must at most 50 characters."),
      state: Yup.string().trim().max(50, "State must at most 50 characters."),
    },
    [["email", "phone"]],
  );

  const thirdPartySchema = Yup.object().shape({
    thirdPartyContractorId: Yup.string().nullable(),
    companyName: Yup.string().required("Company Name is required"),
  });

  const formik = useFormik({
    initialValues,
    validationSchema: is3rdParty
      ? validationSchema.concat(thirdPartySchema)
      : validationSchema,
    context: { is3rdParty },
    onSubmit: (values) => {
      // TODO: do an api call here
      if (onSubmit) {
        onSubmit({
          isOutSourced: is3rdParty,
          values: {
            ...values,
            email: values?.email?.trim()?.toLowerCase(),
            ...(isInvite || is3rdParty
              ? {}
              : {
                  sendOnBoardingLink: sendEmail,
                }),
          },
          beforeCallback,
          successCallback,
          failureCallback,
          afterResponseCallback,
          contractorType:
            !isInvite && is3rdParty
              ? tabValue == 1
                ? "thirdParty"
                : "outSource"
              : values?.contractorType,
          userRole:
            values?.phone && !values?.email
              ? is3rdParty
                ? tabValue == 1
                  ? "thirdPartyContractor"
                  : "outSourceContractor"
                : "contractor"
              : null,
        });
      }
    },
  });

  const {
    values,
    errors,
    handleBlur,
    handleChange,
    touched,
    submitForm,
    setFieldValue,
  } = formik;

  const checkIfUrlExist = useCallback(
    ({ contractorType }) => {
      const foundLink = links?.find((l) => l?.contractorType == contractorType);
      return foundLink ? true : false;
    },
    [links],
  );

  const hasLink = useMemo(() => {
    return checkIfUrlExist({
      contractorType: values?.contractorType || "NA",
    });
  }, [values?.contractorType, checkIfUrlExist]);

  const isTypeTbd = useMemo(() => {
    return values?.contractorType == "TBD" || values?.contractorType == "w2";
  }, [values?.contractorType]);

  // Handlers start...
  const setCityAddress = useCallback(
    (address) => {
      let city,
        state = "";

      for (let i = 0; i < address?.address_components?.length; i++) {
        if (
          address?.address_components?.[i]?.types?.includes(
            "administrative_area_level_1",
          )
        ) {
          state =
            address?.address_components?.[i]?.short_name ||
            address?.address_components?.[i]?.long_name;
        } else if (
          address?.address_components?.[i]?.types?.includes("locality")
        ) {
          city = address?.address_components?.[i]?.long_name;
        }
      }

      setFieldValue("city", city);
      setFieldValue("state", state);
    },
    [setFieldValue],
  );

  function onClose() {
    handleClose();
  }

  const beforeCallback = () => {
    setIsSubmitting(true);
  };

  const successCallback = ({ response, cb }) => {
    formik.resetForm();
  };

  const failureCallback = ({ error }) => {
    // formik.resetForm();
    dispatch({
      type: ALERT_DIALOG,
      payload: {
        open: true,
        title: "Error!",
        message: error?.response?.data?.message || `Some error occured!`,
      },
    });
  };

  const afterResponseCallback = () => {
    setIsSubmitting(false);
  };
  // Handlers end...
  function handleTabChange(_, newValue) {
    setTabValue(newValue);
  }

  React.useEffect(() => {
    if (values?.phone) {
      setFieldValue("phone", getMobileFormat(values?.phone));
    }
  }, [values?.phone]);

  useEffect(() => {
    if (values?.contractorType == "w2") {
      setSendEmail(false);
    }
  }, [values?.contractorType]);

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{ ...style }}>
        <Box className={styles["non-user-container"]}>
          <Typography className={styles["modal-title"]}>
            {isInvite ? "Invite Contractor User" : "Assign Contractor User"}
          </Typography>
          {!isInvite && (
            <BarToggle
              slim
              value={is3rdParty}
              onChange={(val) => {
                setIs3rdParty(val);
                if (val) {
                  setSendEmail(false);
                }
              }}
              leftToggle={false}
              message={"Third Party Contractor"}
              backgroundSx={{
                width: "auto",
                marginLeft: "auto",
              }}
            />
          )}
          <Box
            sx={{
              width: "100%",
              display: is3rdParty ? "inherit" : "none",
            }}
          >
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              TabScrollButtonProps={{
                style: {
                  color: `${getCssVariableHandler({
                    variableName: "--primary-pink-hex",
                  })}`,
                },
              }}
              aria-label="basic tabs example"
              variant="scrollable"
              sx={{
                width: "100%",
                border: "1px solid #D175B6",
                overflow: "hidden",
                display: "inline-flex",
                justifyContent: "space-between",
                borderRadius: "8px",
                "& button": {
                  textTransform: "none",
                  width: "50%",
                  color: "#D175B6",
                  "&.Mui-selected": {
                    backgroundColor: "#D175B6",
                  },
                  "& span": {
                    display: "none",
                  },
                },
                "& .MuiTabs-indicator": {
                  display: "none",
                },
              }}
            >
              <Tab label="Outsourced" id={0} />
              <Tab label="Third Party" id={1} />
            </Tabs>
          </Box>
          <Box className={styles["user-form"]}>
            <Grid container spacing={2}>
              <Grid item md={4} xs={12}>
                <InputLabel>Legal First Name</InputLabel>
                <CustomInput
                  fullWidth
                  placeholder="First Name"
                  name="firstName"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values?.firstName}
                />
                {touched?.firstName && errors?.firstName && (
                  <span className={styles["error"]}>{errors?.firstName}</span>
                )}
              </Grid>

              <Grid item md={4} xs={12}>
                <InputLabel>Legal Middle Name</InputLabel>
                <CustomInput
                  fullWidth
                  placeholder="Middle Name (Optional)"
                  name="middleName"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values?.middleName}
                />
                {touched?.middleName && errors?.middleName && (
                  <span className={styles["error"]}>{errors?.middleName}</span>
                )}
              </Grid>

              <Grid item md={4} xs={12}>
                <InputLabel>Legal Last Name</InputLabel>
                <CustomInput
                  fullWidth
                  placeholder="Last Name"
                  name="lastName"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values?.lastName}
                />
                {touched?.lastName && errors?.lastName && (
                  <span className={styles["error"]}>{errors?.lastName}</span>
                )}
              </Grid>

              <Grid item md={!is3rdParty ? 4 : 6} xs={12}>
                <InputLabel>Email</InputLabel>
                <CustomInput
                  fullWidth
                  placeholder="Email"
                  name="email"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values?.email}
                />
                {touched?.email && errors?.email && (
                  <span className={styles["error"]}>{errors?.email}</span>
                )}
              </Grid>

              <Grid item md={!is3rdParty ? 4 : 6} xs={12}>
                <InputLabel>Phone Number</InputLabel>
                <CustomInput
                  fullWidth
                  placeholder="Phone number"
                  name="phone"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values?.phone}
                />
                {touched?.phone && errors?.phone && (
                  <span className={styles["error"]}>{errors?.phone}</span>
                )}
              </Grid>

              {!is3rdParty && (
                <Grid item md={4} xs={12}>
                  <InputLabel>Contractor Type</InputLabel>
                  <Select
                    fullWidth
                    value={values?.contractorType || ""}
                    displayEmpty
                    name="contractorType"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          overflowY: "auto",
                          "& ul": {
                            overflowY: "auto",
                          },
                        },
                      },
                    }}
                    sx={{
                      color: getCssVariableHandler({
                        variableName: "--white-rgb",
                      }),
                      border: `1px solid ${getCssVariableHandler({ variableName: "--white-rgb" })}`,
                      borderRadius: "0.35rem",
                      height: "50px",
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                      },
                      "& .MuiSvgIcon-root": {
                        color: getCssVariableHandler({
                          variableName: "--white-rgb",
                        }),
                      },
                      "& ul": {
                        overflowY: "auto !important",
                      },
                    }}
                    renderValue={(selected) => {
                      if (!selected || selected === "") {
                        return (
                          <span style={{ color: "rgba(255, 255, 255, 0.5)" }}>
                            Contractor Type
                          </span>
                        );
                      }
                      // Find the label from contractorTypes
                      const type = contractorTypes.find(
                        (t) => t.value === selected,
                      );
                      return type?.label || selected;
                    }}
                  >
                    <MenuItem disabled value="" sx={{ display: "none" }}>
                      Contractor Type
                    </MenuItem>
                    {contractorTypesSelectOptions.map((type) => (
                      <MenuItem key={type.value} value={type.value}>
                        {type.label}
                      </MenuItem>
                    ))}
                  </Select>
                  {touched?.contractorType && errors?.contractorType && (
                    <span className={styles["error"]}>
                      {errors?.contractorType}
                    </span>
                  )}
                </Grid>
              )}

              {!isInvite && is3rdParty && tabValue == 1 && (
                <Grid item xs={12}>
                  <InputLabel>Company Name</InputLabel>
                  <CustomInput
                    fullWidth
                    placeholder="Company Name"
                    name="companyName"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values?.companyName}
                  />
                  {touched.companyName && errors.companyName && (
                    <span className={styles["error"]}>
                      {errors?.companyName}
                    </span>
                  )}
                </Grid>
              )}

              {!isInvite && is3rdParty && tabValue == 0 && (
                <Grid item xs={12}>
                  <InputLabel>Company Name</InputLabel>
                  <CustomBusinessInput
                    handleBlur={handleBlur}
                    onChange={(newVal) => {
                      formik.setFieldValue("companyName", newVal?.companyName);
                      formik.setFieldValue(
                        "thirdPartyContractorId",
                        newVal?._id,
                      );
                    }}
                    value={
                      values?.thirdPartyContractorId
                        ? {
                            companyName: values?.companyName,
                            _id: values?.thirdPartyContractorId,
                          }
                        : null
                    }
                  />
                  {touched.companyName && errors.companyName && (
                    <span className={styles["error"]}>
                      {errors?.companyName}
                    </span>
                  )}
                </Grid>
              )}

              <Grid item md={6} xs={12}>
                <InputLabel>City</InputLabel>
                <AddressFilterAutocomplete
                  filterCities
                  filterStates
                  setAddress={setCityAddress}
                  fullWidth
                  placeholder="City"
                  name="city"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values?.city ?? ""}
                />
                {touched?.city && errors?.city && (
                  <span className={styles["error"]}>{errors?.city}</span>
                )}
              </Grid>

              <Grid item md={6} xs={12}>
                <InputLabel>State</InputLabel>
                <CustomInput
                  fullWidth
                  placeholder="State"
                  name="state"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values?.state}
                />
                {touched?.state && errors?.state && (
                  <span className={styles["error"]}>{errors?.state}</span>
                )}
              </Grid>
            </Grid>
          </Box>
        </Box>

        {isInvite ||
        is3rdParty ||
        ["w2", ""]?.includes(values?.contractorType) ? null : (
          <>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "0.5rem",
                mt: 3,
                ...(!hasLink ? { opacity: "0.75", cursor: "not-allowed" } : {}),
              }}
            >
              <Checkbox
                name="sendemail"
                sx={{
                  cursor: "pointer",
                  padding: "0",
                  color: getCssVariableHandler({
                    variableName: "--white-rgb",
                  }),
                  ...(!hasLink
                    ? { opacity: "0.75", cursor: "not-allowed" }
                    : {}),
                  "&.Mui-checked": {
                    color: getCssVariableHandler({
                      variableName: "--primary-pink-hex",
                    }),
                    "& svg": {
                      fill: getCssVariableHandler({
                        variableName: "--primary-pink-hex",
                      }),
                    },
                  },
                }}
                checked={!!sendEmail}
                onChange={(e) => {
                  if (!hasLink) return;
                  setSendEmail(e?.target?.checked);
                }}
              />
              <Typography>Send an onboarding link to contractor</Typography>
            </Box>

            {!hasLink && !isTypeTbd && (
              <Box
                sx={{
                  display:
                    auth?.canManageGusto || isUserRole(USER_ROLES.SUPERADMIN)
                      ? "flex"
                      : "none",
                  justifyContent: "center",
                  alignItems: "center",
                  mt: "1rem",
                  width: "100%",
                  paddingLeft: "1rem",
                }}
              >
                <Typography>
                  No onboarding link is currently set up for this contractor
                  type.{" "}
                  {auth?.addAdpLink ? (
                    <>
                      <a
                        className="email-link"
                        href="/configuration/contractor-links"
                        target="_blank"
                      >
                        Click here
                      </a>{" "}
                      to add.
                    </>
                  ) : (
                    "Please contact payroll to add/update links."
                  )}
                </Typography>
              </Box>
            )}
          </>
        )}
        <Box className="bottom-btn-box">
          <Button className="btn-black" onClick={onClose}>
            <Typography className="btn-text">Close</Typography>
          </Button>

          <Button
            className="btn-pink"
            onClick={() => {
              submitForm();
            }}
            disabled={isSubmitting || isLoading}
          >
            {isSubmitting || isLoading ? (
              <CircularProgress size={22} />
            ) : (
              <Typography className="btn-text">
                {isInvite ? "Invite User" : "Assign User"}
              </Typography>
            )}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

SendOppToNonUserModal.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  isInvite: PropTypes.bool,
  positionData: PropTypes.array,
};